// src/flux/action/loginAction.js

import { clearLocalStorage } from '../../utils/common';
import {
  getTokenFromCode,
  logoutRequest,
  getUserInfo,
  postUserTimeZoneInfo,
} from '../../service/authService';
import { NEW_LOGIN_CONFIG, SSO_TYPE } from '../../utils/newLoginConfig';
import { clearActiveSessions } from './activeSessions';

export const LoginActionsEnum = {
  SAVE_USER_INFO: 'SAVE_USER_INFO',
};

export const saveUserInfoAction = (userInfo) => ({
  type: LoginActionsEnum.SAVE_USER_INFO,
  payload: userInfo,
});

export const getUserInfoFromToken = () => async (dispatch) => {
  try {
    const res = await getUserInfo();

    if (res && res.uid) {
      localStorage.setItem('userInfo', JSON.stringify(res));

      dispatch(saveUserInfoAction(res));
    } else {
      console.error('No uid in response!');
    }

    if (res?.email) {
      postUserTimeZoneInfo(res.email);
    }
  } catch (error) {
    console.error('getUserInfoFromToken error:', error);
    throw error;
  }
};

const generateLoginUrl = (type) => {
  const { AUTH_URL, STATE, REDIRECT_URL, IAM_RESPONSE_TYPE } = NEW_LOGIN_CONFIG;
  const ssoType = type === 'identity' ? SSO_TYPE.OPENAM : SSO_TYPE.IAM;
  const stateParam = type === 'identity' ? STATE : IAM_RESPONSE_TYPE;
  return `${AUTH_URL}/auth/v1/login?sso=${ssoType}&state=${stateParam}&redirect=${REDIRECT_URL}`;
};

export const login = (type) => {
  const redirectUrl = generateLoginUrl(type);

  window.location.replace(redirectUrl);
};

export const getLogin = (codeStr) => async (dispatch) => {
  try {
    const res = await getTokenFromCode(codeStr);

    if (res && res?.data && res?.data?.token) {
      localStorage.setItem('accessToken', res?.data?.token);
      localStorage.setItem('refreshToken', res?.data?.refresh_token || '');

      return res?.data?.token;
    } else {
      console.error('No token in response!');
      return '';
    }
  } catch (error) {
    console.error('getLogin error:', error);
    throw error;
  }
};

export const logout = () => async (dispatch) => {
  try {
    const res = await logoutRequest();
    dispatch(clearActiveSessions());
    if (res) {
      clearLocalStorage();
      dispatch(saveUserInfoAction({}));
    }
  } catch (error) {
    console.error('Logout error:', error);
    dispatch(clearActiveSessions());
    clearLocalStorage();
    dispatch(saveUserInfoAction({}));
  }
};

export const saveUserInfo = (user) => async (dispatch) => {
  dispatch(saveUserInfoAction(user));
};

export const loginAction = {
  login,
  logout,
  getLogin,
  saveUserInfo,
  getUserInfoFromToken,
};
